import { useEffect, useState } from 'react'

/**
 * Whether the browser believes it is online. `navigator.onLine` is an
 * optimistic signal — true can still mean a captive portal or a dead
 * tunnel — so it drives a banner that informs, never one that blocks;
 * a request that actually fails is the authority (`classifyFailure`).
 */
export function useOnline() {
  const [online, setOnline] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine !== false))

  useEffect(() => {
    const up = () => setOnline(true)
    const down = () => setOnline(false)
    window.addEventListener('online', up)
    window.addEventListener('offline', down)
    return () => {
      window.removeEventListener('online', up)
      window.removeEventListener('offline', down)
    }
  }, [])

  return online
}
